export class InstrumentoDuplicarModel {
  constructor({ codigoTag = null, flagCamposAdicionais = true, participanteId = null }) {
    this.codigoTag = codigoTag;
    this.flagCamposAdicionais = flagCamposAdicionais;
    this.participanteId = participanteId;
  }
}
